<template>
    <div class="w-4/5 mr-4">
        <input id="cohosts" type="text" name="cohosts" 
            :value="value.name"
            @input="update('name', $event.target.value)"
            placeholder="Search for a cohost."
            >
        <ul :value="value.id" class="cohosts-dropdown" v-if="isSearching">
            <button @click="closeDropdown()" class="close-dropdown">x</button>
            <li v-for="organization in searchedOrganizations" :key="organization.id">
                <a href="#" @click.stop.prevent="selectOrganization(organization)">{{ organization.name }}</a>
            </li>
        </ul>
    </div>
</template>

<script>

import _ from 'lodash'

export default {
    name: "CohostsSearch",
    props: ['value', 'clear'],
    data: () => ({
        organizationId: null,
        isSearching: false,
        isSelected: false,
        searchedOrganizations: {}
    }),
    created: function () {
        this.debouncedGetOrganizations = _.debounce(this.getOrganizations, 500)
    },
   watch: {
        value: {
            handler(val) {
                if(!this.isSelected) {
                    this.debouncedGetOrganizations()
                }
            },
            deep: true
        },
        clear: function(toggle) {
            if(toggle) {
                this.closeDropdown()
                this.isSelected = false
            }
        }
    },
    methods: {
        getOrganizations() {
            this.isSelected = false
            this.isSearching = true

            axios.get(laroute.route('api.organizations.search', {
                keyword: this.value.name,
                pagination: true
            }))
            .then((response) => {
                this.searchedOrganizations = response.data.data
            })
        },
        update(key, value) {
            this.$emit('input', { ...this.value, [key]: value })
        },
        selectOrganization(organization) {
            this.value.name = organization.name
            this.value.id = organization.id
            this.isSelected = true
            this.closeDropdown()
        },
        closeDropdown() {
            this.isSearching = false
            this.searchedOrganizations = {}
        }
    }
}
</script>